import { useState, useEffect } from "react";
import { ILowesStormDoorHandleListing } from "../../../../entities-generated/models/lowes-storm-door-handle/lowes-storm-door-handle-listing";
import { BwjPageContent } from "../../../../framework/components/bwj-page-content";
import { BwjPageHeader } from "../../../../framework/components/bwj-page-header";
import { BwjViewState, BwjViewManager } from "../../../../framework/components/bwj-view-manager";
import { useNavigator } from "../../../../framework/services/navigation";
import { AppRoutes } from "../../../app-routes";
import { LowesStormHandleListItem } from "../../components/handle-listing";
import { LowesStormDoorHandleApiClient } from "../../../../services/lowes-storm-door-handle";

export const PageImportedLowesStormHandles: React.FunctionComponent = () => {
  const nav = useNavigator();
  const [viewState, setViewState] = useState(BwjViewState.Loading);
  const [handles, setHandles] = useState<ILowesStormDoorHandleListing[]>([]);

  useEffect(() => {
    LowesStormDoorHandleApiClient.getImportedStormDoorHandleList()
    .then(h => {
      setHandles(h);
      setViewState(BwjViewState.Ready);
    })
    .catch(() => setViewState(BwjViewState.Error));
  }, []);

  const onHandleSelected = (handle: ILowesStormDoorHandleListing) => {
    nav.goTo(AppRoutes.publishLowesStormHandle.url(handle.id));
  }
  
  return (
    <BwjViewManager
      state={viewState}
      loadingState={{
        message: 'Loading imports...',
      }}
      errorState={{
        message: 'An unexpected error occurred'
      }}
    >
      <BwjPageHeader
        title={'Imported Storm Door Handles (Lowe\'s)'}
        titleIconName={AppRoutes.importedLowesStormHandles.icon}
      />
      <BwjPageContent contentDescription={'primary content (no subcontent)'}>
        {handles.map(handle =>
        <LowesStormHandleListItem
          key={handle.id}
          listing={handle}
          onClick={onHandleSelected}
        />)}
      </BwjPageContent>
    </BwjViewManager>
  );
};